@if (reading.parked(); as parked) {
  @if (!asWindow()) {
    <aside class="chip web-ui" aria-label="Libro que estabas leyendo">
      <button class="chip__restore" type="button" (click)="reading.resume()" aria-label="Volver al libro"><mat-icon aria-hidden="true">keyboard_arrow_up</mat-icon></button>
      <button class="chip__identity" type="button" (click)="reading.resume()" [attr.aria-label]="'Seguir leyendo ' + parked.bookName">
        @if (parked.cover) {<img [src]="parked.cover | coverCache | async" alt="">}
        <span><small>{{parked.place}}</small><strong>{{parked.bookName}}</strong></span>
      </button>
      <button class="chip__close" type="button" (click)="reading.dismiss()" aria-label="Cerrar"><mat-icon aria-hidden="true">close</mat-icon></button>
    </aside>
  }
}
